@if (isLoading) {
<div>
  <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>Loading...
</div>
}

@if (errorMessage) {
<div><p-message severity="error" [text]="errorMessage"></p-message></div>
}

@if (workOrder && !isLoading) {
<form id="workOrderForm" #workOrderForm="ngForm" class="container">
  <div class="row iPhoneFix">
    <div class="col-12">
      <h4 style="display: inline-block; margin-right: 8px;">Quote Maintenance</h4>@if (workOrder.id) {
      <i class="fa fa-link" (click)="copyOneClickLink()" pTooltip="Click to copy 1-click quote link"></i>
      }
    </div>
    <div class="col-12 row">
      <!-- Common top section includes basic WO information such as customer, address, representative, message to customer -->
      <app-work-order-maintenance-common-fields-top [(workOrder)]="workOrder" [isEditable]="isEditable"
        [isCustomer]="isCustomer">
      </app-work-order-maintenance-common-fields-top>
      <div style="margin-top: 8px;">
        @if (showReset) {
        <p-button type="button" severity="warn" label="Undo Customer Approval" [disabled]="disableReset"
          (click)="resetToEditable()">
        </p-button>
        }
      </div>
      <div class="col-6">
        <div class="bold">
          Regional Manager
        </div>
        @if (workOrder) {
        <ng-select class="custom" required [searchable]="false" [selectOnTab]="true" [items]="employees"
          placeholder="Select a Regional Manager" name="rep" bindLabel="fullName" [(ngModel)]="workOrder.representative"
          (ngModelChange)="repChanged()" [disabled]="!isEditable || !changeRM">
        </ng-select>
        }
      </div>
      <div class="col-6">
        <div class="bold">
          Payment Due
        </div>
        @if (workOrder) {
        <ng-select class="custom" required [searchable]="false" [selectOnTab]="true" [items]="paymentDueOptions"
          placeholder="Select an Option" name="paymentDueOption" bindLabel="paymentDueName"
          [(ngModel)]="workOrder.paymentDueOption" [disabled]="!isEditable">
        </ng-select>
        }
      </div>
      <div class="col-12">
        <span class="bold">Priority</span>
        @if (workOrder) {
        <app-priority-and-date-selector [(taskOrQuote)]="workOrder" [isEditable]="isEditable"
          [showRangeCalculationOption]="true" (changedRequiredFields)="setCanAddNewTask()">
        </app-priority-and-date-selector>
        }
      </div>
      @if (!isCustomer) {
      <div class="col-2 container" style="text-align: left;">
        <div class="row">
          <p-button type="button" (click)="addNewWelnessTask()" class="smallButton col col-2" [disabled]="!isEditable"
            severity="primary" fluid label="Add Wellness Task">
          </p-button>
          <p-button type="button" (click)="addNewWorkTask()" class="smallButton col col-2" severity="primary" fluid
            [disabled]="!isEditable" label="Add Work Task">
          </p-button>
        </div>
      </div>
      }
    </div>
    @if (workOrder) {
    <div class="row no-gutter" style="width: 100%;">
      @for (wowt of workOrder.workOrderWellnessTasks; track wowt) {
      <div class="col-12 col-lg-4 no-gutter" style="padding: 8px !important;"
        [ngClass]="{'taskComplete': wowt.wellnessTask.completionStatus == 'Completed' || wowt.wellnessTask.completionStatus =='Unable to be Completed'}">
        <app-work-order-maintenance-wellness-task-card [workOrderWellnessTask]="wowt" [isCustomer]="isCustomer"
          [isEditable]="isEditable" [fromQuote]="true" [customerId]="workOrder.customer.id"
          [quoteNumber]="workOrder.quoteNumber" [hidePrice]="workOrder.hidePrice"
          (copyWellnessTaskEvent)="copyWellnessTask($event)" (editWellnessTaskEvent)="editWellnessTask($event)"
          (deleteWellnessTaskEvent)="deleteWellnessTask($event)" (taskSelectedChangeEvent)="setSelectedTasks()">
        </app-work-order-maintenance-wellness-task-card>
      </div>
      }
      @for (wowt of workOrder.workOrderWorkTasks; track wowt) {
      <div class="col-12 col-lg-4 no-gutter" style="padding: 8px !important;"
        [ngClass]="{'taskComplete': wowt.workTask.completionStatus == 'Completed' || wowt.workTask.completionStatus =='Unable to be Completed' }">
        <app-work-order-maintenance-work-task-card [workOrderWorkTask]="wowt" [isEditable]="isEditable"
          [isCustomer]="isCustomer" [fromQuote]="true" [hidePrice]="workOrder.hidePrice"
          (copyWorkTaskEvent)="copyWorkTask($event)" (deleteWorkTaskEvent)="deleteWorkTask($event)"
          (editWorkTaskEvent)="editWorkTask($event)" (taskSelectedChangeEvent)="setSelectedTasks()">
        </app-work-order-maintenance-work-task-card>
      </div>
      }
    </div>
    }
    <!-- Neighbor's permission section -->
    <div class="col-12">
      <div class="bold">Neighbors Permission Required: </div>
      @if (workOrder) {
      <p-radiobutton name="permissionRequired" [value]="true" [(ngModel)]="workOrder.neighborPermissionRequired"
        [disabled]="!isEditable" (ngModelChange)="neighborPermissionChange()" required>
      </p-radiobutton>
      <label>Yes</label>
      }&nbsp;&nbsp;
      @if (workOrder) {
      <p-radiobutton name="permissionNotRequired" [value]="false" [(ngModel)]="workOrder.neighborPermissionRequired"
        [disabled]="!isEditable" (ngModelChange)="neighborPermissionChange()" required>
      </p-radiobutton>
      <label>No</label>
      }
    </div>
    @for (neighborPermission of workOrder.neighborPermissions; track neighborPermission; let i = $index) {
    <div>
      @if (!neighborPermission.deleted) {
      <div class="col-12">
        <div>Enter Neighbor's Address</div>
        <p>
          <input pInputText [name]="'neighborAddress-'+i" [(ngModel)]="neighborPermission.address"
            [required]="workOrder.neighborPermissionRequired" [disabled]="!isEditable" />
        </p>
        <div>Describe Activities to be Performed on Neighbor's Property</div>
        <div>
          <input pInputText [name]="'neighborActivities-'+i"
            [(ngModel)]="neighborPermission.activitiesOnNeighborProperty"
            [required]="workOrder.neighborPermissionRequired" [disabled]="!isEditable" />
        </div>
        <div style="margin-top: 5px;">
          @if (isEditable) {
          <p-button type="button" severity="danger" label="Remove Neighbor Permission" [disabled]="!isEditable"
            (click)="removeNeighborPermission(i)">
          </p-button>
          }
        </div>
      </div>
      }
    </div>
    }
    @if (workOrder?.neighborPermissionRequired) {
    <div class="col-12">
      <p-button type="button" label="Add Another Neighbor Permission" [disabled]="!isEditable"
        (click)="addNeighborPermission()">
      </p-button>
    </div>
    }
    <div class="col-12">
      <div class="bold">Multi-Day Job: </div>
      @if (workOrder) {
      <p-radiobutton name="isMultiday" [value]="true" [(ngModel)]="workOrder.isMultiday" [disabled]="!isEditable"
        required>
      </p-radiobutton>
      <label>Yes</label>
      }&nbsp;&nbsp;
      @if (workOrder) {
      <p-radiobutton name="isNotMultiday" [value]="false" [(ngModel)]="workOrder.isMultiday" [disabled]="!isEditable"
        required>
      </p-radiobutton>
      <label>No</label>
      }
    </div>
    <div class="col-12">
      <div class="bold">Outside Expenses: </div>
      @if (workOrder) {
      <p-radiobutton name="hasRentalExpense" [value]="true" [(ngModel)]="workOrder.hasRentalExpense"
        [disabled]="!isEditable" required>
      </p-radiobutton>
      <label>Yes</label>
      }&nbsp;&nbsp;
      @if (workOrder) {
      <p-radiobutton name="noRentalExpense" [value]="false" [(ngModel)]="workOrder.hasRentalExpense"
        [disabled]="!isEditable" required>
      </p-radiobutton>
      <label>No</label>
      }
    </div>
    @if (workOrder?.hasRentalExpense) {
    <div class="col-12">
      <div>Outside Cost(s)</div>
      <p>
        <input pInputText name="rentalCosts" numeric [textMask]="{mask: currencyMask}"
          [(ngModel)]="workOrder.rentalCost" [required]="workOrder.hasRentalExpense" [disabled]="!isEditable"
          (ngModelChange)="workOrder.rentalCost=$event" />
      </p>
      <div>Describe Outside Cost(s)</div>
      <div>
        <input pInputText name="rentalDescription" [(ngModel)]="workOrder.rentalDescription"
          [required]="workOrder.hasRentalExpense" [disabled]="!isEditable" />
      </div>
    </div>
    }
    <div class="col-12">
      <div class="bold">Hide Price From Crew: </div>
      @if (workOrder) {
      <p-radiobutton name="hidePrice" [value]="true" [(ngModel)]="workOrder.hidePrice" [disabled]="!isEditable"
        required>
      </p-radiobutton>
      <label>Yes</label>
      }&nbsp;&nbsp;
      @if (workOrder) {
      <p-radiobutton name="dontHidePrice" [value]="false" [(ngModel)]="workOrder.hidePrice" [disabled]="!isEditable"
        required>
      </p-radiobutton>
      <label>No</label>
      }
    </div>
    @if (workOrder) {
    <div class="row">
      <div class="col-12">
        <h6>Quote Documents/Photos</h6>
        <app-blob-manager [angularUpload]="true" [containerName]="'quote'" [parentRecordId]="workOrder.id" [uploadLabel]="'Document/Photo'"
          [viewOnly]="!isEditable">
        </app-blob-manager>
      </div>
    </div>
    }
    <div class="col-12 row">
      @if (workOrder) {
      <div class="row">
        <div class="col-12">
          <h6>Message to the Customer</h6>
          @if (workOrder) {
          <ng-select class="custom" style="margin-bottom: .5rem;" [searchable]="false" [selectOnTab]="true"
            [items]="templates" placeholder="Select a Message Template" name="template" bindLabel="name"
            [(ngModel)]="selectedTemplate" (ngModelChange)="templateChanged()" [disabled]="!isEditable">
          </ng-select>
          }
          @if (workOrder) {
          <textarea pInputTextarea name="note" [(ngModel)]="workOrder.note" [disabled]="!isEditable" [rows]="5"
            style="width: 100%;" placeholder="Message to the Customer..."></textarea>
          }
        </div>
        @if (!isCustomer) {
        <div class="col-12">
          <h6>Message to the Crew</h6>
          @if (workOrder) {
          <textarea pInputTextarea name="crewNote" [(ngModel)]="workOrder.crewNote" [disabled]="!isEditable" [rows]="5"
            style="width: 100%;" placeholder="Message to the Crew..."></textarea>
          }
        </div>
        }
      </div>
      }
      @if (!isCustomer) {
      <div class="col-6 multiselect">
        <h6>Required Skill(s)/Certification(s)</h6>
        @if (workOrder) {
        <p-multiselect autofocusFilter placeholder=" " [options]="requiredSkills" name="requiredSkills" [ngModel]="requiredSkills" [panelStyle]="{minWidth:'12em'}" fluid
          optionLabel="name" disabled defaultLabel="">
          <ng-template let-value pTemplate="selectedItems">
            @for (val of value; track val) {
            <div class="ui-multiselected-item-token ui-corner-all">
              <span>{{val.name}}</span>
            </div>
            }
            @if (!value || value.length === 0) {
            <span style="width: 150px;" class="ui-multiselected-empty-token ui-corner-all">No Skills Required</span>
            }
          </ng-template>
          <ng-template let-skill pTemplate="item">
            {{skill.label}}
          </ng-template>
        </p-multiselect>
        }
      </div>
      }
      @if (!isCustomer) {
      <div class="col-6 multiselect">
        <h6>Required Equipment</h6>
        @if (workOrder) {
        <p-multiselect autofocusFilter placeholder=" " [options]="requiredEquipment" name="requiredEquipment" [ngModel]="requiredEquipment" fluid
          [panelStyle]="{minWidth:'12em'}" optionLabel="type" disabled defaultLabel="">
          <ng-template let-value pTemplate="selectedItems">
            @for (val of value; track val) {
            <div class="ui-multiselected-item-token ui-corner-all">
              <span>{{val.type}}</span>
            </div>
            }
            @if (!value || value.length === 0) {
            <span style="width: 180px;" class="ui-multiselected-empty-token ui-corner-all">No Equipment Required</span>
            }
          </ng-template>
          <ng-template let-role pTemplate="item">
            {{role.label}}
          </ng-template>
        </p-multiselect>
        }
      </div>
      }
    </div>
    <div class="col-12">
      <!-- Common bottom section includes total information such as price adjustments, subtotal, sales tax, total -->
      <app-work-order-maintenance-common-fields-bottom [(workOrder)]="workOrder" [isEditable]="isEditable"
        [isCustomer]="isCustomer" [hidePrice]="workOrder.hidePrice" [isQuote]="true"
        (priceAdjustmentDeleted)="deletePriceAdjustment($event)"></app-work-order-maintenance-common-fields-bottom>
    </div>
  </div>
  <div class="row">
    <div class="col-12 columnPadding">
      @if (workOrderForm.invalid && workOrderForm.submitted) {
      <div class="alert alert-danger" role="alert">
        There are errors on this page. Please correct the errors and resubmit.
      </div>
      }
    </div>
    <div class="col-12" style="text-align: right;">
      @if (workOrder.customerSignature) {
      <app-signature-area [isAlwaysDisabled]="!isEditable" [signature]="workOrder.customerSignature"
        [name]="'Customer'">
      </app-signature-area>
      }
      @if (!isCustomer) {
      <div class="fine-print" style="text-align: right;">
        Last Sent: {{workOrder.lastSent ? (workOrder.lastSent | date: 'short') : 'Not Sent'}}
      </div>
      }
      @if (!canSave) {
      <p-button type="button" severity="warn" (click)="cancel('quote')" label="Back"></p-button>
      }
      @if (canSave) {
      <p-button type="button" severity="warn" (click)="cancel('quote')"
        [label]="isEditable ? 'Cancel ': 'Back'"></p-button>
      }
      @if (!isCustomer && !showReactivate && workOrder && workOrder.id) {
      <p-button type="submit" severity="success" (click)="displayApproveDialog = true" [disabled]="saving || !canSave || isApproving"
        label="Approve Quote"></p-button>
      }
      @if (!isCustomer && !showReactivate) {
      <p-button type="submit" severity="success" (click)="saveAndSend(workOrderForm)" [disabled]="saving || !canSave"
        label="Save and Send"></p-button>
      }
      @if (!isCustomer && showReactivate) {
      <p-button type="submit" severity="success" (click)="reactivate()" [disabled]="saving || !showReactivate"
        label="Renew Quote"></p-button>
      }
      @if (canSign && isCustomer) {
      <p-button type="submit" (click)="createWOs(workOrderForm)"
        [disabled]="!canSign || (workOrder && !workOrder.id) || (!selectedWorkTasks.length && !selectedWellnessTasks.length) || saving"
        [label]="acceptText"></p-button>
      }
      @if (canSign && isCustomer) {
      <p-button type="button" severity="danger" (click)="rejectQuote()"
        [disabled]="!canSign || (workOrder && !workOrder.id) || saving" [label]="rejectText"></p-button>
      }
      @if (!showReactivate) {
      <p-button type="submit" severity="success" (click)="save(workOrderForm)" [disabled]="saving || !canSave"
        label="Save"></p-button>
      }
    </div>
  </div>
</form>
}

<!-- Add New Wellness Task dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
        it needs to scroll because it looks weird otherwise. -->
@if (displayWellnessTaskDialog) {
<div class="scrollableDialog">
  <p-dialog header="Wellness Task Info" [(visible)]="displayWellnessTaskDialog" [modal]="true" [resizable]="false"
    [baseZIndex]="10000" [maximizable]="false" [breakpoints]="{'1600px': '50vw', '500px': '100vw'}" [focusOnShow]="false"
    (onHide)="cancelledTask()" [closable]="true" (visibleChange)="cancelledTask()" [blockScroll]="true">

    <app-wellness-task-maintenance (timeToClose)="closedDialog($event)" (cancelled)="cancelledTask($event)"
      (delete)="deleteWellnessTaskByTask($event)" [workOrder]="workOrder" [task]="selectedWellnessTask"
      [showRangeCalculationOption]="true"></app-wellness-task-maintenance>
  </p-dialog>
</div>
}

<!-- Add New Work Task dialog -->
<!-- Only dialogs inside class scrollableDialog get the CSS for scrolling. Only use scrollableDialog if the dialog actually has enough content that
        it needs to scroll because it looks weird otherwise. -->
@if (displayWorkTaskDialog) {
<div class="scrollableDialog">
  <p-dialog header="Work Task Info" [(visible)]="displayWorkTaskDialog" [modal]="true" [resizable]="false"
    [baseZIndex]="10000" [maximizable]="false" [breakpoints]="{'1600px': '50vw', '500px': '100vw' }" [focusOnShow]="false"
    (onHide)="cancelledTask()" [closable]="true" (visibleChange)="cancelledTask()" [blockScroll]="true">
    <app-work-task-maintenance (timeToClose)="closedDialog($event)" (cancelled)="cancelledTask($event)"
      (delete)="deleteWorkTaskByTask($event)" [workOrder]="workOrder" [task]="selectedWorkTask"
      [showRangeCalculationOption]="true"></app-work-task-maintenance>
  </p-dialog>
</div>
}

@if (displayApproveDialog) {
<p-dialog header="Approve" [(visible)]="displayApproveDialog" [modal]="true" [resizable]="false" [baseZIndex]="10000"
  appendTo="body">
  <form>
    <div class="form-group">
      This will approve the quote without a signature and add <b>all</b> tasks to the created work order(s), please add
      a note on why you are not getting customer approval.
      <textarea pInputTextarea name="approvalComment" class="form-control" [required]="true" style="width: 100%;"
        autoResize="autoResize" [(ngModel)]="approvalComment" placeholder="Add note..."></textarea>
    </div>
    <div class="form-group">
      <p-button type="button" type="submit" [disabled]="!approvalComment" (click)="approveWithoutCustomer()"
        [disabled]="isApproving" label="Approve"></p-button>&nbsp;
      <p-button type="button" (click)="approvalComment = undefined; displayApproveDialog=false;" label="Cancel"
        [disabled]="isApproving" severity="info"></p-button>
    </div>
  </form>
</p-dialog>
}